<section class="section-wrapper">
  <!-- Section Header -->
  <h2 class="section-title">Recent Incidents</h2>

  <!-- Container for the list of cards -->
  <div class="dashboard-card-list-container">
    <!-- Loop through cardsData to render each card -->
    <ng-container
      *ngIf="recentIncidents && recentIncidents.length > 0; else noData"
    >
      <div class="dashboard-card" *ngFor="let incident of recentIncidents">
        <div class="card-content-area">
          <!-- Dynamic rendering based on card type/data structure -->
          <div class="card-row">
            <strong>{{ "Incident Id" }}:</strong
            ><span>{{ incident.incidentId }}</span>
          </div>
          <div class="card-row">
            <strong>Date:</strong><span>{{ incident.eventCreateDate }}</span>
          </div>
          <div class="card-row">
            <strong>Incident Name:</strong
            ><span>{{ incident.incidentName }}</span>
          </div>
          <div class="card-description">
            {{ incident.incidentDescription }}
          </div>
          <div class="card-row status-row">
            <!-- Added status-row class for specific styling -->
            <strong>Status:</strong>
            <!-- Status is now a clickable button -->
            <button
              class="incident-status status-button {{
                getStatusInfo(incident.incidentStatus).statusClass
              }}"
            >
              {{ getStatusInfo(incident.incidentStatus).statusText }}
            </button>
          </div>
        </div>
        <div class="card-actions">
          <button>Go to Details</button>
        </div>
      </div>
    </ng-container>
    <!-- Message when no data is available -->
    <ng-template #noData>
      <div class="no-data-message">No Recent Incidents</div>
    </ng-template>
  </div>
</section>
